module.exports = __webpack_public_path__ + "static/BrandonGrotesque-RegularItalic-10adcddb6e8337956f8b8b21c9f787a9.woff";